import { ClassNameMap, DialogTitle, DialogTitleProps, IconButton, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';

export const useStyles = makeStyles<ModalTitleProps>()(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2, 3),
    position: 'relative',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '32px',
    letterSpacing: '0.25px',
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      fontSize: '22px',
    }
  },
  closeButton: {
    position: 'absolute',
    right: '12px',
    top: '12px',
    color: theme.palette.grey[500],
    zIndex: 1
  },
}));


export type ModalTitleProps = DialogTitleProps & {
  onClose?: () => void;
  disabled?: boolean;
  classes?: Partial<ClassNameMap<'root' | 'title' | 'closeButton'>>;
};

export const ModalTitle: React.FC<ModalTitleProps> = ({ children, onClose, disabled, ...props }) => {
  const { classes } = useStyles(props, { props });

  return (
    <DialogTitle component="div" className={classes.root} {...props}>
      <Typography className={classes.title} variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton disabled={disabled} aria-label="close" className={classes.closeButton} onClick={onClose} data-testid="close-modal-button">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>

  );
};
